@if (showVideoInline()) {
  <video class="inline mat-elevation-z8" controls [src]="contentUrl"></video>
}
@if (showAudioInline()) {
  <audio class="inline" controls [src]="contentUrl"></audio>
}
@if (showImageInline()) {
  <a class="icon-link" role="button" (click)="openContentDialog($event)">
    <img class="inline mat-elevation-z8" [alt]="vfile?.description" [src]="thumbUrl">
    <!--       [attr.imageSrc]="contentUrl" [attr.thumbSrc]="thumbUrl"-->
  </a>
}

@if (showLink()) {
  <a class="icon-link" role="button" (click)="openContentDialog($event)">{{ getLinkName() }}
    <mat-icon inline="true">{{ getIcon() }}</mat-icon>
  </a>
}
